import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "Appointment.AppointmentScreeningForm.title",
    defaultMessage: "Patient Information",
  },
  headerNameTitle: {
    id: "Appointment.AppointmentScreeningForm.headerNameTitle",
    defaultMessage: "Name",
  },
  headerDateOfBirthTitle: {
    id: "Appointment.AppointmentScreeningForm.headerDateOfBirthTitle",
    defaultMessage: "Date of birth",
  },
  headerPatientIdTitle: {
    id: "Appointment.AppointmentScreeningForm.headerPatientIdTitle",
    defaultMessage: "Patient ID",
  },
  dateTitle: {
    id: "Appointment.AppointmentScreeningForm.dateTitle",
    defaultMessage: "Date",
  },
  patientSignatureTitle: {
    id: "Appointment.AppointmentScreeningForm.patientSignatureTitle",
    defaultMessage: "Patient Signature",
  },
  patientUnderstandingText: {
    id: "Appointment.AppointmentScreeningForm.patientUnderstandingText",
    defaultMessage:
      "I verify that I do not have any of the metallic objects listed above within or on my body. If I have some I cannot remove I will inform the technologist and discuss and accept the risks of an MRI should I proceed with the exam. By checking this I confirm I understand this acts as a digital signature.",
  },
  cancelButtonTitle: {
    id: "Appointment.AppointmentScreeningForm.cancelButtonTitle",
    defaultMessage: "Cancel",
  },
  saveButtonTitle: {
    id: "Appointment.AppointmentScreeningForm.saveButtonTitle",
    defaultMessage: "Save",
  },
  metalicElectronicItemsTitle: {
    id: "Appointment.AppointmentScreeningForm.metalicElectronicItemsTitle",
    defaultMessage: "Metallic/Electronic Items",
  },
  metalicElectronicItemsFirstParagraph: {
    id: "Appointment.AppointmentScreeningForm.metalicElectronicItemsFirstParagraph",
    defaultMessage:
      "All metallic and electronic items must be removed in order for you to receive an MRI scan.",
  },
  metalicElectronicItemsSndParagraph: {
    id: "Appointment.AppointmentScreeningForm.metalicElectronicItemsSndParagraph",
    defaultMessage:
      "Having one of the items below does not automatically disqualify you from receiving a scan. Instead, it provides our technologist with important information that will allow them to discuss additional risks and accommodate you as needed.",
  },
  metalicElectronicItemsThirdParagraph: {
    id: "Appointment.AppointmentScreeningForm.metalicElectronicItemsThirdParagraph",
    defaultMessage:
      "If you are unsure if any of the following apply to you, please check the item and indicate that you wish to speak with an MRI Technologist or give us a call before you come in for your scan. We will be happy to answer any questions.",
  },
  metalicElectronicItemsFourthParagraph: {
    id: "Appointment.AppointmentScreeningForm.metalicElectronicItemsFourthParagraph",
    defaultMessage: "Please select if you have any of the following:",
  },
  cardiacPacemakerText: {
    id: "Appointment.AppointmentScreeningForm.cardiacPacemakerText",
    defaultMessage: "Cardiac Pacemaker",
  },
  implantedCardiacDefibrillatorText: {
    id: "Appointment.AppointmentScreeningForm.implantedCardiacDefibrillatorText",
    defaultMessage:
      "Implanted Cardiac Defibrillator, Cardiac Electrodes, Pacing Wires, Internal Electrodes",
  },
  aneurysmClipText: {
    id: "Appointment.AppointmentScreeningForm.aneurysmClipText",
    defaultMessage: "Aneurysm Clip(s)",
  },
  cochlearText: {
    id: "Appointment.AppointmentScreeningForm.cochlearText",
    defaultMessage: "Cochlear, Otologic, or other Ear Implant",
  },
  hearingAidText: {
    id: "Appointment.AppointmentScreeningForm.hearingAidText",
    defaultMessage: "Hearing Aid",
  },
  softTissueExpanderText: {
    id: "Appointment.AppointmentScreeningForm.softTissueExpanderText",
    defaultMessage: "Soft Tissue Expander (e.g. breast)",
  },
  swanGanzCatheterText: {
    id: "Appointment.AppointmentScreeningForm.swanGanzCatheterText",
    defaultMessage: "Swan-Ganz Catheter",
  },
  workedWithMetalText: {
    id: "Appointment.AppointmentScreeningForm.workedWithMetalText",
    defaultMessage: "Worked with Metal OR Metal Fragments in Eyes",
  },
  eyeProsthesisText: {
    id: "Appointment.AppointmentScreeningForm.eyeProsthesisText",
    defaultMessage:
      "Eye Prosthesis or device such as eyelid spring, wire, or implant",
  },
  metallicFragmentOrForeignBodyText: {
    id: "Appointment.AppointmentScreeningForm.metallicFragmentOrForeignBodyText",
    defaultMessage:
      "Metallic Fragment or Foreign Body such as, but not limited to, bullets or shrapnel",
  },
  heartValveProsthesisText: {
    id: "Appointment.AppointmentScreeningForm.heartValveProsthesisText",
    defaultMessage: "Heart Valve Prosthesis",
  },
  electronicImplantText: {
    id: "Appointment.AppointmentScreeningForm.electronicImplantText",
    defaultMessage: "Electronic Implant or Device",
  },
  neurostimulationText: {
    id: "Appointment.AppointmentScreeningForm.neurostimulationText",
    defaultMessage: "Neurostimulation or Spinal Cord Stimulator",
  },
  boneGrowthStimulatorText: {
    id: "Appointment.AppointmentScreeningForm.boneGrowthStimulatorText",
    defaultMessage: "Bone Growth Stimulator",
  },
  implantCardTitle: {
    id: "Appointment.AppointmentScreeningForm.implantCardTitle",
    defaultMessage: "Implant Card",
  },
  implantCardDescription: {
    id: "Appointment.AppointmentScreeningForm.implantCardDescription",
    defaultMessage:
      "If you have an implant card please upload an image of the front and back on the {patientInformationForm} during check-in or email it to hello@imagomri.com.",
  },
  patientInformationFormText: {
    id: "Appointment.AppointmentScreeningForm.patientInformationFormText",
    defaultMessage: "“Patient Information” form",
  },
  magneticallyActivatedImplantText: {
    id: "Appointment.AppointmentScreeningForm.magneticallyActivatedImplantText",
    defaultMessage: "Magnetically Activated Implant or Device",
  },
  magneticStentCoilFilterText: {
    id: "Appointment.AppointmentScreeningForm.magneticStentCoilFilterText",
    defaultMessage: "Magnetic Stent, Coil, or Filter",
  },
  wireMeshImplantText: {
    id: "Appointment.AppointmentScreeningForm.wireMeshImplantText",
    defaultMessage: "Wire Mesh Implant",
  },
  surgicalStaplesClipsMetallicSuturesText: {
    id: "Appointment.AppointmentScreeningForm.surgicalStaplesClipsMetallicSuturesText",
    defaultMessage: "Surgical Staples, Clips, or Metallic Sutures",
  },
  anyOtherProsthesisText: {
    id: "Appointment.AppointmentScreeningForm.anyOtherProsthesisText",
    defaultMessage: "Any Other Prosthesis (Limb, Penile Implant, Eye)",
  },
  jointReplacementText: {
    id: "Appointment.AppointmentScreeningForm.jointReplacementText",
    defaultMessage: "Joint Replacement",
  },
  boneJointText: {
    id: "Appointment.AppointmentScreeningForm.boneJointText",
    defaultMessage: "Bone/Joint Pin or Screw, Nail, Wire, or Plate",
  },
  iudDiaphragmPessaryText: {
    id: "Appointment.AppointmentScreeningForm.iudDiaphragmPessaryText",
    defaultMessage: "IUD, Diaphragm, or Pessary",
  },
  medicinePatchesText: {
    id: "Appointment.AppointmentScreeningForm.medicinePatchesText",
    defaultMessage: "Medicine Patches",
  },
  shuntText: {
    id: "Appointment.AppointmentScreeningForm.shuntText",
    defaultMessage: "SHUNT(S) - spinal/intraventricular/peritoneal",
  },
  infusionPumpText: {
    id: "Appointment.AppointmentScreeningForm.infusionPumpText",
    defaultMessage:
      "Infusion Pump such as Insulin Pump or Other Drug Infusion Device",
  },
  dentalImplantsText: {
    id: "Appointment.AppointmentScreeningForm.dentalImplantsText",
    defaultMessage: "Dentures, Magnetic Dental Implants, or Hearing Aids",
  },
  bodyPiercingJewelryText: {
    id: "Appointment.AppointmentScreeningForm.bodyPiercingJewelryText",
    defaultMessage: "Body Piercing Jewelry",
  },
  tattoosOrPermanentMakeupText: {
    id: "Appointment.AppointmentScreeningForm.tattoosOrPermanentMakeupText",
    defaultMessage: "Tattoos or Permanent Makeup",
  },
  anyOtherDeviceText: {
    id: "Appointment.AppointmentScreeningForm.anyOtherDeviceText",
    defaultMessage: "Any Other Device or Object in Body",
  },
  metalicElectronicItemsFifthParagraph: {
    id: "Appointment.AppointmentScreeningForm.metalicElectronicItemsFifthParagraph",
    defaultMessage:
      "If you checked any of the above, please discuss the details with your MRI Technologist.",
  },
  doNotHaveAnyItemTitle: {
    id: "Appointment.AppointmentScreeningForm.doNotHaveAnyItemTitle",
    defaultMessage: "I do not have any of the above.",
  },
  itemRemovalTitle: {
    id: "Appointment.AppointmentScreeningForm.itemRemovalTitle",
    defaultMessage: "Item Removal",
  },
  itemRemovalDescription: {
    id: "Appointment.AppointmentScreeningForm.itemRemovalDescription",
    defaultMessage:
      "We will provide a locker so any items you remove may be stored and locked safely during your scan. You may bring the key in the scan room with you. Before entering the MRI machine please:",
  },
  itemRemovalFirstRecomendationTitle: {
    id: "Appointment.AppointmentScreeningForm.itemRemovalFirstRecomendationTitle",
    defaultMessage: "Remove all jewelry, body piercings, and hair accessories.",
  },
  itemRemovalSndRecomendationTitle: {
    id: "Appointment.AppointmentScreeningForm.itemRemovalSndRecomendationTitle",
    defaultMessage:
      "Remove dentures, false teeth, partial dental plates, retainers.",
  },
  itemRemovalThirdRecomendationTitle: {
    id: "Appointment.AppointmentScreeningForm.itemRemovalThirdRecomendationTitle",
    defaultMessage: "Remove hearing aids and eyeglasses.",
  },
  itemRemovalFourthRecomendationTitle: {
    id: "Appointment.AppointmentScreeningForm.itemRemovalFourthRecomendationTitle",
    defaultMessage:
      "Lock your clothes and valuables in the locker provided and remove the key.",
  },
  itemRemovalFifthRecomendationTitle: {
    id: "Appointment.AppointmentScreeningForm.itemRemovalFifthRecomendationTitle",
    defaultMessage: "Use the restroom before your MRI exam.",
  },
  technologistNotesTitle: {
    id: "Appointment.AppointmentScreeningForm.technologistNotesTitle",
    defaultMessage: "Technologist Notes",
  },
  technologistNotesTextFieldPlaceholder: {
    id: "Appointment.AppointmentScreeningForm.technologistNotesTextFieldPlaceholder",
    defaultMessage: "Technologist notes",
  },
  technologistSignatureTitle: {
    id: "Appointment.AppointmentScreeningForm.technologistSignatureTitle",
    defaultMessage: "Technologist Signature",
  },
  technologistSignatureVerifyText: {
    id: "Appointment.AppointmentScreeningForm.technologistSignatureVerifyText",
    defaultMessage:
      "As the technologist performing the MRI scan, I have reviewed the screening form with the patient and verify that the patient may safely undergo the MRI scan. By checking this I confirm I understand this acts as a digital signature",
  },
  pregnancyConsentTitle: {
    id: "Appointment.AppointmentScreeningForm.pregnancyConsentTitle",
    defaultMessage: "Pregnancy Consent",
  },
  pregnancyConsentFirstText: {
    id: "Appointment.AppointmentScreeningForm.pregnancyConsentFirstText",
    defaultMessage:
      "This consent is to inform you the Magnetic Resonance Imaging (MRI) non-contrast procedure you are having today is at a possible risk to your unborn child/fetus. By signing this you are consenting to understanding all of the information below and have asked all questions needed to understand the risks associated with the procedure.",
  },
  pregnancyConsentSndText: {
    id: "Appointment.AppointmentScreeningForm.pregnancyConsentSndText",
    defaultMessage:
      "To date, there are no reports of injury to children who underwent MR imaging before birth. While the number of patients scanned during pregnancy is small, with limited follow-up, in the past several years, numerous pregnant patients have undergone non-contrast MRI with no ill effects.",
  },
  pregnancyConsentThirdText: {
    id: "Appointment.AppointmentScreeningForm.pregnancyConsentThirdText",
    defaultMessage: "I",
  },
  pregnancyConsentFourthText: {
    id: "Appointment.AppointmentScreeningForm.pregnancyConsentFourthText",
    defaultMessage:
      "have read the above warning and understand the potential harmful effects to my unborn fetus. I consent to have this MRI procedure understanding the potential risks. I acknowledge that I have been given ample opportunity to ask questions and that all questions have been answered to my satisfaction. Furthermore, I fully understand that I may refuse to have this MRI procedure conducted on me. Also, I understand that I may stop this MRI procedure at anytime during its process. Furthermore, I fully agree that the risks described herein are risks that I am willing to accept. Also, I agree that I will hold harmless Imago MRI of Pelham, LLC, owners, and employees should I, or my fetus, experience any negative effects from this MRI procedure.",
  },
  patientPregnancyConfirmationLabel: {
    id: "Appointment.AppointmentScreeningForm.patientPregnancyConfirmationLabel",
    defaultMessage: "Pregnancy Confirmation",
  },
  patientPregnancyConfirmationText: {
    id: "Appointment.AppointmentScreeningForm.patientPregnancyConfirmationText",
    defaultMessage: "Are you pregnant or feel there is any chance you may be?",
  },
});
